import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import uniqBy from 'lodash/uniqBy';
import QuickGroupDtcs from './QuickGroupDtcs';
import QuickGroupMaintenances from './QuickGroupMaintenances';
import QuickGroupAlarms from './QuickGroupAlarms';

import './QuickHealth.css';

@inject('translationsStore', 'commonStore')
@observer
export default class QuickHealth extends Component {
  render() {
    const { translationsStore } = this.props;
    let { car } = this.props;
    let nextIntervention = {};
    // TODO collegamento a My Desk
    // nextIntervention = {
    //   key: 'booked',
    //   label: translationsStore.translate('quickhealth.nextIntervention.enum.booked'),
    //   date: '2018-10-08T17:25',
    //   interventionDate: '2018-10-22T10:30'
    // };
    let { maintenances = [] } = car || {};
    if (maintenances.length > 0) {
      // MEMO replicating car maintenances dataset manipulation as done in AIR My Desk
      const nextFactoryMaintenance = maintenances
        .filter((maintenance) => !maintenance.custom)
        .filter((maintenance) => moment(maintenance.virtualDate).isAfter(moment()))
        .sort((a, b) => (moment(a.virtualDate).isAfter(b.virtualDate) || !b.virtualDate ? 1 : moment(a.virtualDate).isBefore(b.virtualDate) || !a.virtualDate ? -1 : 0))
        .shift();
      const allNextCustomMaintenance = maintenances.filter(maintenance => maintenance.custom);
      const maintenancesFromUnmanagedLeads = maintenances.filter(maintenance => !!maintenance.leadId && !maintenance.performed);
      let computedMaintenances;
      computedMaintenances = [nextFactoryMaintenance]
        .concat(allNextCustomMaintenance, maintenancesFromUnmanagedLeads)
        .sort((a, b) => (moment(a.virtualDate).isAfter(b.virtualDate) ? 1 : moment(a.virtualDate).isBefore(b.virtualDate) ? -1 : 0))
        .filter((maintenance) => maintenance !== undefined);
      computedMaintenances = uniqBy(computedMaintenances, 'id');
      car = { ...car, maintenances: computedMaintenances };
    }

    return (
      <div className="QuickHealth">
        <div className="NextIntervention">
          <div>
            <div className="NextInterventionLabel">{translationsStore.translate('quickhealth.nextIntervention.labelStatus')}:</div>
            <div className="NextInterventionValue">{'label' in nextIntervention ? nextIntervention.label : '-'}</div>
          </div>
          <div>
            <div className="NextInterventionLabel">{translationsStore.translate('quickhealth.nextIntervention.labelDate')}:</div>
            <div className="NextInterventionValue">{'date' in nextIntervention ? moment(nextIntervention.date).format('DD/MM/YYYY - HH:mm') : '-'}</div>
          </div>
          <div>
            <div className="NextInterventionLabel">{translationsStore.translate('quickhealth.nextIntervention.labelInterventionDate')}:</div>
            <div className="NextInterventionValue">{'interventionDate' in nextIntervention ? moment(nextIntervention.interventionDate).format('DD/MM/YYYY - HH:mm') : '-'}</div>
          </div>
        </div>

        <div className="QuickCardContainer">
          <QuickGroupAlarms car={car} />
          <QuickGroupMaintenances car={car} />
        </div>
        <QuickGroupDtcs car={car} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickHealth.js